import styled from "styled-components";

export const TableWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;

export const FilterBarWrapper = styled.div`
  margin-bottom: 16px;
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin-left: 20px;
  margin-right: 20px;
`;

export const FilterItem = styled.div`
  min-width: 200px;
`;
